export default __webpack_public_path__ + "static/media/pma_token_card.d6fb5fa4.png";